import Telemetry from '@atlassian/mpac-telemetry';
import { useHistory, useLocation } from '@atlassian/mpac-ui';
import { useEffect } from 'react';
function TelemetryNavigationListener(_ref) {
  let {
    getRouteName
  } = _ref;
  const {
    pathname
  } = useLocation();
  Telemetry.setPage(getRouteName(pathname));
  const history = useHistory();
  useEffect(() => {
    history.listen(location => {
      const pageName = getRouteName(location.pathname);
      Telemetry.setPage(pageName);
    });
  }, []);
  return null;
}
export default TelemetryNavigationListener;